import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import '@grandvisionhq/analytics';
import '../../../../../context/actions.js';
import '../../../../../context/reducer.js';
import '../../../../../types/product.js';
import '../../../../../context/ProductContext.js';
import '../../../../../context/CmsContext.js';
import '@swc/helpers';
import { ProductAnalyticsEvents } from '../../../../Analytics/events/ProductAnalyticsEvents.js';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/utils';
import '@grandvisionhq/graphql';
import '@grandvisionhq/svc-tealium/utils';
import '../../../../../hooks/useCartDiscountsQuery/types.js';
import '../../../../../operations/queries/get-accessories-by-slug.js';
import '../../../../../operations/queries/get-contact-lens-by-slug.js';
import '../../../../../operations/queries/get-frames-by-slug.js';
import '../../../../../operations/queries/get-solutions-by-slug.js';
import '../../../../../operations/queries/get-sunglasses-by-slug.js';
import '../../../../../operations/queries/get-ready-reader-by-slug.js';
import '../../../../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '../../../../../operations/queries/get-manufacturer-by-key.js';
import '../../../../../hooks/use-product-view-history.js';
import '@grandvisionhq/frk-routing';
import 'classnames';
import '@grandvisionhq/common';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import '@grandvisionhq/lib-visuals';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/lib-utils-react';
import '@grandvisionhq/forms';
import '@grandvisionhq/inventory';
import '../../../../../slots/context.js';
import '@grandvisionhq/lib-cookies';
import '@grandvisionhq/content';
import { WITHOUT_RX, WITH_RX } from '../../../components/RxableSelect/contants.js';
import { isRxRadioSelection } from '../../../components/RxableSelect/is-rx-radio-selection.js';
import '@grandvisionhq/lib-utils-html';
import { useSunglassesEcommContext } from '../../context/SunglassesEcommContext.js';
import { SunglassesRxableSelect } from './SunglassesRxableSelect.js';

const SunglassesRxableSelectContainer = ({ className  })=>{
    const { selectWithRxLens , setSelectWithRxLens  } = useSunglassesEcommContext();
    const { getLabel  } = useIntl();
    const radioButtonItems = React.useMemo(()=>[
            {
                value: WITHOUT_RX,
                label: getLabel('products.selectRxAble.withoutRx'),
                iconName: 'sunglasses'
            },
            {
                value: WITH_RX,
                label: getLabel('products.selectRxAble.withRx'),
                iconName: 'store-eye-test'
            }, 
        ]
    , [
        getLabel
    ]);
    const onRxRadioChange = React.useCallback((newSelection)=>{
        if (isRxRadioSelection(newSelection) && selectWithRxLens !== newSelection) {
            setSelectWithRxLens(newSelection);
            ProductAnalyticsEvents.pushPdpSunglassesRxSelectionEvent(newSelection === WITH_RX);
        }
    }, [
        selectWithRxLens,
        setSelectWithRxLens
    ]);
    return /*#__PURE__*/ React.createElement(SunglassesRxableSelect, {
        items: radioButtonItems,
        onChange: onRxRadioChange,
        selectedValue: selectWithRxLens,
        className: className
    });
};

export { SunglassesRxableSelectContainer };
//# sourceMappingURL=SunglassesRxableSelectContainer.js.map
